import type { FC } from "react";

import style from "./styles/Form.module.scss";

export interface FormLabelProps {
  // horizontalLayout?: boolean;
  children: React.ReactNode;
  hotspotId?: any;
}

const FormLabel: FC<FormLabelProps> = (props) => {
  //const labelClasses = clsx({ [style.horizontal_input_label]: props.horizontalLayout });

  return (
    <>
      {props.hotspotId && <span id={props.hotspotId} className="hotspot-beacon" />}
      <label className={style.input_label} data-testid={"form-label"}>
        {props.children}
      </label>
    </>
  );
};

export { FormLabel };
